import { Button, Group } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { ConnectionStatusBadge } from '../../ConnectionStatus/ConnectionStatusBadge'
import { ConnectionStatus } from '../../useTestConnectionStatus'

type TestMqttConnectionProps = {
  status: ConnectionStatus
  errorMessage?: string
  disabled?: boolean
  onTestConnection: () => void
}

export const TestMqttConnection = ({
  status,
  errorMessage,
  disabled,
  onTestConnection
}: TestMqttConnectionProps) => {
  return (
    <Group align="center" gap="lg">
      <Button
        size="xs"
        loading={status === 'pending'}
        disabled={disabled}
        onClick={onTestConnection}
      >
        <FormattedMessage id="integrations.mqtt.broker.testConnection" />
      </Button>

      <ConnectionStatusBadge status={status} detail={errorMessage} />
    </Group>
  )
}
